module.exports = __webpack_public_path__ + "static/media/BONEswap.486ab657.png";